import { Label } from '@mui/icons-material';
import { Container, Divider, Grid, Paper } from '@mui/material';
import React from 'react';
import { Loading, useTranslate } from 'react-admin';
import CustomChart from '../components/chart/CustomChart';
import LatestOrders from '../components/latestOrders/LatestOrders';
import DashboardItem from './DashboardItem';
import { useCounts, useLatestOrders } from './hooks/useDashboard';
import OrdersMovementChart from './OrdersMovementChart';

function Dashboard() {
  const t = useTranslate();
  const { data, isLoading } = useCounts();
  const { data: latestOrders, isLoading: isLoadingOrders } = useLatestOrders();

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Container>
      <Grid container>
        <Grid
          item
          lg={6}
          md={6}
          sm={12}
          style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
        >
          <DashboardItem
            title={t('orders')}
            count={data?.orders}
            link={'/order'}
          />
        </Grid>

        <Grid
          item
          lg={6}
          md={6}
          sm={12}
          style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
        >
          <DashboardItem
            title={t('customers')}
            count={data?.users}
            link={'/user'}
          />
        </Grid>

        <Grid
          item
          lg={4}
          md={6}
          sm={12}
          style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
        >
          <DashboardItem
            title={t('products')}
            count={data?.products}
            link={'/product'}
          />
        </Grid>

        <Grid
          item
          lg={4}
          md={6}
          sm={12}
          style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
        >
          <DashboardItem
            title={t('categories')}
            count={data?.categories}
            link={'/category'}
          />
        </Grid>

        <Grid
          item
          lg={4}
          md={6}
          sm={12}
          style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10 }}
        >
          <DashboardItem
            title={t('categories')}
            count={100}
            link={'/products'}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
      <Grid style={{ padding: 2 }} container>
        <Grid style={{ padding: 2 }} item lg={12} md={12} sm={12}>
          <LatestOrders orders={latestOrders} />
        </Grid>
        <Grid style={{ padding: 2 }} item lg={12} md={12} sm={12}>
          <Paper sx={{ padding: 2 }}>
            <OrdersMovementChart />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Dashboard;
